import { API_URLS } from '../../../components/common/headers';
import { protectApiViaOkta } from '../../../utils/protectApiViaOkta';

export class SearchService {
  static async getCountries(region) {
    const url = `${API_URLS.getCountriesURL}?region=` + region;

    return protectApiViaOkta('get', url);
  }

  static generateSearchDataObject = (region, data, bread = '') => {
    const res = {
      label: region,
      children: [],
      bread: !bread ? region : `${bread} > ${region}`,
    };

    if (!data) return res;

    if (Array.isArray(data)) {
      res.children = data
        .sort()
        .map((_value) => ({ label: _value, bread: `${res.bread} > ${_value}` }));
    } else if (typeof data === 'object') {
      res.children = Object.entries(data).map(([_key, _value]) => {
        return this.generateSearchDataObject(_key, _value, res.bread);
      });
    }

    return res;
  };
}
